import i18n from "../../i18n";

/**
 * Locale de formatage des dates et des nombres, déduite de la langue active.
 *
 * Elle était codée en dur à "fr-FR" dans une dizaine de composants : en
 * anglais, les dates sortaient « 3 oct. » et les montants « 17 800 » avec
 * l'espace fine française. Deux composants faisaient déjà ce choix à la main
 * (ResultsFilters, DetailsTrip) ; cette fonction leur donne un point commun.
 */
export const currentLocale = () =>
  String(i18n.language || "fr").toLowerCase().startsWith("en") ? "en-US" : "fr-FR";

export default currentLocale;
